import { gql } from '@apollo/client'

/** Shared AdvisorSession fields for list + detail. Types may lag FE schema codegen. */
export const ADVISOR_SESSION_FRAGMENT = gql`
  fragment AdvisorSessionFragment on ScoAdvisorSession {
    id
    advisorSessionId
    expertUserId
    seekerUserId
    advisorProfileId
    statusKey
    status {
      id
      key
      title
    }
    hourlyRate
    approximateLengthMinutes
    reason
    suggestedTime1
    suggestedTime2
    suggestedTime3
    suggestedByUserId
    scheduledAt
    requestedAt
    expiresAt
    confirmedAt
    startedAt
    endedAt
    durationSeconds
    estimatedCostUsd
    finalCostUsd
    platformFeePercent
    platformFeeAmount
    expertShareAmount
    streamCallType
    streamCallId
    canceledByUserId
    cancelationReason
    settledAt
    ratingPromptedAt
    canRate
    currentUserRating {
      id
      ratingId
      score
      note
      rateableType
      rateableId
    }
    createdAt
    updatedAt
    currentUserRole
    expertUser {
      id
      userId
      slug
      fullName
      displayName
      pictureUrl
    }
    seekerUser {
      id
      userId
      slug
      fullName
      displayName
      pictureUrl
    }
    advisorProfile {
      id
      advisorProfileId
      hourlyRate
      isSessionEnabled
      timezone
      canAcceptSessions
    }
  }
`
